import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as instructorActions from "../../_actions/roster.actions";
import dates from "react-big-calendar/lib/utils/dates";
import TimeGridHeaderDaily from "./TimeGridHeaderDaily";
import TimeGutter from "react-big-calendar/lib/TimeGutter";
import moment from "moment";
import memoize from "memoize-one";
import Resources from "react-big-calendar/lib/utils/Resources";
import getWidth from "dom-helpers/width";
import DayColumnDaily from "./DayColumnDaily";
import cn from "classnames";
import DayColumnTotal from "./DayColumnTotal";
import TimeGridTotal from "./TimeGridTotal";
import _ from "lodash";

class DailyReportContents extends Component {
  constructor(props) {
    super(props);
    this.state = { gutterWidth: undefined, isOverflowing: null };
    this.gutterRef = React.createRef();
  }

  static defaultProps = {
    step: 60,
    timeslots: 1,
    min: dates.startOf(new Date(), "day"),
    max: dates.endOf(new Date(), "day"),
    scrollToTime: dates.startOf(new Date(), "day"),
    getNow: () => new Date()
  };

  componentDidMount = () => {
    this.measureGutter();
    // initialize displayWeeklyEvents
    // let cond = {};
    // cond.view = 'work';
    // this.props.actions.updateDailyReportEvents(cond);
  };

  // gutterRef = ref => {
  //     this.gutter = ref && findDOMNode(ref)
  // }

  componentWillReceiveProps = () => {
    this.measureGutter();
  };

  measureGutter() {
    // let node = findDOMNode(this.gutterRef.current);
    let node = document.getElementById("timegutter");
    const width = getWidth(node);

    if (width && this.state.gutterWidth !== width) {
      this.setState({ gutterWidth: width });
    }
  }

  memoizedResources = memoize((resources, accessors) =>
    Resources(resources, accessors)
  );

  renderEvents(events, now, date) {
    let { employees, min, max, components, accessors, localizer } = this.props;

    return employees.map((emp, jj) => {
      // Filter events by employee and date
      let daysEvents = (events || []).filter(
        event =>
          event.EmployeeID === emp.EmployeeAutoID &&
          (dates.diff(event.start, date, "day") == 0 ||
            dates.diff(event.end, date, "day") == 0)
      );

      return (
        <DayColumnDaily
          {...this.props}
          min={dates.merge(date, min)}
          max={dates.merge(date, max)}
          localizer={localizer}
          components={components}
          key={jj}
          date={date}
          daysEvents={daysEvents || []}
        />
      );
    });
  }

  renderTotal = (date, events) => {
    let { min, max, components, localizer, employees } = this.props;

    let daysEvents = [];

    employees.map(emp => {
      let _daysEvents = (events || []).filter(
        event =>
          event.EmployeeID === emp.EmployeeAutoID &&
          (dates.diff(event.start, date, "day") == 0 ||
            dates.diff(event.end, date, "day") == 0)
      );
      daysEvents = _.concat(daysEvents, _daysEvents);
    });
    // (events || []).filter(
    //   event =>
    //     employees.filter(emp => emp.EmployeeID === event.EmployeeID).length > 0 &&
    //     dates.diff(event.start, date, 'day') == 0 ||
    //     dates.diff(event.end, date, 'day') == 0
    // );

    return (
      <DayColumnTotal
        {...this.props}
        min={dates.merge(date, min)}
        max={dates.merge(date, max)}
        localizer={localizer}
        components={components}
        date={date}
        daysEvents={daysEvents || []}
      />
    );
  };

  render() {
    let { localizer, date, getNow } = this.props;

    let start = getNow();

    let min = moment("12:00am", "h:mma").toDate();
    let max = moment("11:59pm", "h:mma").toDate();

    const eventsList = _.map(this.props.events, (obj, key) => {
      return obj;
    });

    return (
      <div className="rbc-time-view reporting">
        <TimeGridHeaderDaily
          date={date}
          localizer={localizer}
          width={this.state.gutterWidth}
          getNow={this.props.getNow}
          employees={this.props.employees}
          isOverflowing={true}
        />

        <div ref="content" className="rbc-time-content">
          <TimeGutter
            date={start}
            ref={this.gutterRef}
            localizer={localizer}
            min={dates.merge(start, min)}
            max={dates.merge(start, max)}
            step={this.props.step}
            getNow={this.props.getNow}
            timeslots={this.props.timeslots}
            components={<div />}
            className="rbc-time-gutter"
          />
          {this.renderEvents(eventsList, getNow, date)}
          {this.renderTotal(date, eventsList)}
        </div>
        <TimeGridTotal
          date={date}
          localizer={localizer}
          width={this.state.gutterWidth}
          getNow={this.props.getNow}
          employees={this.props.employees}
          isOverflowing={true}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.roster.displayDailyReportEvents,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList,
    actionTypes: state.ActionTypesReducer.actionTypes
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(instructorActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DailyReportContents);
